var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodMenuWhite = function SvgFoodMenuWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H7M12 6H7M2 1v14M12.667 2H5v12h7.667c.735 0 1.333-.598 1.333-1.333V3.333C14 2.598 13.402 2 12.667 2Z",
    stroke: "#30384C",
    strokeWidth: 2
  })));
};
export default SvgFoodMenuWhite;